import React from 'react';

import { AuthProvider } from './AuthContext';
import { SearchProvider } from './SearchContext'
import { ParentProvider } from './ParentContext'
import { FilterProvider } from './FilterContext'

const AppProvider = ({ children }) => {
  return (
    <AuthProvider>
      <ParentProvider>
        <SearchProvider>
          <FilterProvider>

          {children}
          </FilterProvider>
        </SearchProvider>
      </ParentProvider>
    </AuthProvider>
  );

}

export default AppProvider;
